import { Route, Routes, Navigate } from "react-router-dom";

import useAuth from "hooks/use-auth";
import Login from "pages/Login";
import AboutUs from "pages/aboutus";
import DisplayUsers from "pages/users";
import EditUser from "pages/users/edit";
import DisplayCatalogs from "pages/catalogs";
import DisplayCatalog from "pages/catalogs/catalog";
import AddProductsCategory from "pages/products/category/add";
import DisplayProducts from "pages/products";
import AddProduct from "pages/products/add";
import EditProduct from "pages/products/edit";
import Sms from "pages/sms";
import AddMessageFrame from "pages/messageFrame";
import EditMessageFrame from "pages/messageFrame/edit";
import AddProductsSubCategory from "pages/products/subCategory/add";
import EditProductsCategory from "pages/products/category/edit";
import EditProductsSubCategory from "pages/products/subCategory/edit";
import DisplayServices from "pages/services";
import AddService from "pages/services/add";
import EditService from "pages/services/edit";
import AddServicesSubCategory from "pages/services/subcategory/add";
import EditServicesSubCategory from "pages/services/subcategory/edit";
import DisplayArticles from "pages/articles";
import AddArticle from "pages/articles/add";
import EditArticle from "pages/articles/edit";
import AddArticlesCategory from "pages/articles/subcategory/add";
import EditArticlesCategory from "pages/articles/subcategory/edit";
import DisplayEducation from "pages/education";
import AddEducation from "pages/education/add";
import EditEducation from "pages/education/edit";
import AddEducationCategory from "pages/education/subcategory/add";
import EditEducationCategory from "pages/education/subcategory/edit";
import DisplayRecords from "pages/records";
import AddRecords from "pages/records/add";
import EditRecords from "pages/records/edit";
import AddRecordsSubCategory from "pages/records/subcategory/add";
import EditRecordsSubCategory from "pages/records/subcategory/edit";
import DisplayWorkSamples from "pages/work_samples";
import AddWorkSample from "pages/work_samples/add";
import EditWorkSample from "pages/work_samples/edit";
import AddWorkSamplesCategory from "pages/work_samples/category/add";
import EditWorkSampleCategory from "pages/work_samples/category/edit";
import Messages from "pages/Messages";
import MessageDetails from "pages/Messages/messageDetail";
import Gallery from "pages/gallery";
import Slides from "pages/MainPageSlides";
import ProductsCategory from "pages/products/category";
import ProductsSubCategory from "pages/products/subCategory";
import EditSlides from "pages/MainPageSlides/edit";

export default function RoutesCM() {
  const AuthCTX = useAuth();

  if (!AuthCTX.isLoggedIn) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<DisplayCatalogs />} />
      <Route path="/aboutus" element={<AboutUs />} />

      {/* users routes*/}
      <Route path="/users" element={<DisplayUsers />} />
      <Route path="/users/edit/:user_id" element={<EditUser />} />

      {/*catalogs routes*/}
      <Route path="/catalogs" element={<DisplayCatalogs />} />
      <Route path="/catalogs/:catalog_id" element={<DisplayCatalog />} />

      {/*products routes*/}
      <Route path="/products" element={<DisplayProducts />} />
      <Route path="/products/add" element={<AddProduct />} />
      <Route path="/products/edit/:product_id" element={<EditProduct />} />

      {/*products category routes */}
      <Route path="/products/category" element={<ProductsCategory />} />

      <Route path="/products/category/add" element={<AddProductsCategory />} />

      <Route
        path="/products/category/edit/:products_category_id"
        element={<EditProductsCategory />}
      />

      {/* products subcategory routes */}
      <Route
        path="/products/category/:products_category_id/subcategory"
        element={<ProductsSubCategory />}
      />
      <Route
        path="/products/category/:products_category_id/subcategory/add"
        element={<AddProductsSubCategory />}
      />
      <Route
        path="/products/category/:products_category_id/subcategory/edit/:products_subcategory_id"
        element={<EditProductsSubCategory />}
      />

      {/* message routes */}
      <Route path="/sms" element={<Sms />} />
      <Route path="/frame/add" element={<AddMessageFrame />} />
      <Route path="/frame/edit/:frame_id" element={<EditMessageFrame />} />

      {/* services routes */}
      <Route path="/services" element={<DisplayServices />} />
      <Route path="/services/add" element={<AddService />} />
      <Route path="/services/edit/:service_id" element={<EditService />} />
      {/* services subcategory routes */}
      <Route
        path="/services/subcategory/add"
        element={<AddServicesSubCategory />}
      />
      <Route
        path="/services/subcategory/edit/:services_subcategory_id"
        element={<EditServicesSubCategory />}
      />
      {/* articles routes */}
      <Route path="/articles" element={<DisplayArticles />} />
      <Route path="/articles/add" element={<AddArticle />} />
      <Route path="/articles/edit/:article_id" element={<EditArticle />} />
      {/* articles subcategory routes */}
      <Route path="/articles/category/add" element={<AddArticlesCategory />} />
      <Route
        path="/articles/category/edit/:articles_category_id"
        element={<EditArticlesCategory />}
      />
      {/* education routes */}
      <Route path="/education" element={<DisplayEducation />} />
      <Route path="/education/add" element={<AddEducation />} />
      <Route path="/education/edit/:education_id" element={<EditEducation />} />
      {/* education category routes */}
      <Route
        path="/education/category/add"
        element={<AddEducationCategory />}
      />
      <Route
        path="/education/category/edit/:education_category_id"
        element={<EditEducationCategory />}
      />
      {/* records routes */}
      <Route path="/records" element={<DisplayRecords />} />
      <Route path="/records/add" element={<AddRecords />} />
      <Route path="/records/edit/:records_id" element={<EditRecords />} />
      {/* records subcategory routes */}
      <Route
        path="/records/subcategory/add"
        element={<AddRecordsSubCategory />}
      />
      <Route
        path="/records/subcategory/edit/:records_subcategory_id"
        element={<EditRecordsSubCategory />}
      />

      {/* workSamples routes */}
      <Route path="/work_samples" element={<DisplayWorkSamples />} />
      <Route path="/work_samples/add" element={<AddWorkSample />} />
      <Route
        path="/work_samples/edit/:work_sample_id"
        element={<EditWorkSample />}
      />
      {/* workSamples category routes
      <Route
        path="/work_samples/category/add"
        element={<AddWorkSamplesCategory />}
      />
      <Route
        path="/work_samples/category/edit/:work_sample_category_id"
        element={<EditWorkSampleCategory />}
      /> */}

      {/* users message routes */}
      <Route path="/messages" element={<Messages />} />
      <Route
        path="/messages/details/:message_id"
        element={<MessageDetails />}
      />

      {/* gallery route */}
      <Route path="/gallery" element={<Gallery />} />

      {/* main page slides route  */}
      <Route path="/slides" element={<Slides />} />
      <Route path="/slides/edit/:slide_img_id" element={<EditSlides />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
